<template>
  <multi-select-all
    v-bind="$attrs"
    v-on="$listeners"
    v-model="innerValue"
    :items="roles"
  ></multi-select-all>
</template>

<script>
import MultiSelectAll from "@/components/MultiSelectAll.vue";
export default {
  props: ["value"],
  components: { MultiSelectAll },
  data() {
    return {
      roles: ["Administrator", "Member", "Trustee"],
      innerValue: null,
    };
  },
  computed: {
    // showSpecific() {
    //   return v !== null && v !== undefined ? true : false;
    // },
  },
  watch: {
    value: {
      handler(v) {
        // console.log("value is ", v);
        if (v !== null && v !== undefined) {
          this.innerValue = v;
        } else {
          this.innerValue = JSON.parse(JSON.stringify(this.roles));
        }
      },
    },
    innerValue: {
      handler(v) {
        // console.log("inner value is ", v);
        let value =
          JSON.stringify(this.innerValue) === JSON.stringify(this.roles)
            ? null
            : v;
        this.$emit("update:value", value);
      },
    },
  },
  mounted() {
    // console.log("mounted value is ", this.value);
    if (this.value !== null && this.value !== undefined) {
      this.innerValue = this.value;
    } else {
      this.innerValue = JSON.parse(JSON.stringify(this.roles));
    }
  },
};
</script>
